<template>
    <v-layout class="owner" v-if="post">
        <v-flex xs10 sm8>
            <v-list-tile class="owner__listavatar listavtarnew">
                <v-list-tile-avatar size="40" class="owner__image">
                    <img :src="sizeFormattedImageUrl(post.authorProfilePicture, 150, 150)"
                         :onerror="imageErrorFallback(post.authorFallbackProfileImageUrl)">
                </v-list-tile-avatar>

                    <v-list-tile-content>
                        <v-list-tile-sub-title class="owner__name">
                            <a data-qe-id="post-owner_open_profile_link" @click="openMemberProfile">
                                {{commentOwnerName}}
                            </a>
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title class="owner__chapter" data-qe-id="post-owner_chapter_name">
                            {{post.authorChapter}}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title
                            class="owner__community"
                            data-qe-id="post-owner_post-name"
                            @click="openCommunity(post)"
                            v-if="showCommunityAllNetwork_Home">
                            {{post.name}}
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
            </v-list-tile>
            <v-flex class="visible-xs owner__time_date">
                <v-icon color="ypo_blue_grey" class="time">access_time</v-icon>
                <span data-qe-id="post-owner_post-time">{{postTime}}</span>
            </v-flex>
        </v-flex>
        <v-flex
            xs2
            sm4
            text-xs-right
            class="owner__time_align">
            <v-icon
                slot="activator"
                color="ypo_blue"
                v-if="isAdminPagePost && post.hasBeenMarkedInappropriate"
                id="post_inappropirate_flag_btn"
                data-qe-id="post_inappropirate_flag_btn"
                @click="promptAdminInappropriatePost()">flag
            </v-icon>
            <span class="owner__detail-time hidden-xs" data-qe-id="post_post_time">
                {{postTime}}
            </span>
            <v-icon color="ypo_blue_grey" class="owner__detail-time__icon hidden-xs">access_time</v-icon>
            <v-menu
                class="menu-tile"
                offset-y
                left
                v-show="postActions.length > 0"
                v-if="!isAdminPagePost"
                :class="isAdminPagePost ? 'bock-cursor' : ''">
                <v-icon
                    slot="activator"
                    color="ypo_extra-light-gray"
                    v-if="!post.hasBeenMarkedInappropriate"
                    :data-qe-id="post.parentPostId ? 'comment_options_btn' : 'post_options_btn'"
                    :id="post.parentPostId ? 'comment_options_btn' : 'post_options_btn'">
                    more_vert
                </v-icon>
                <v-list class="owner__menu">
                    <v-list-tile
                        class="owner__menu-item"
                        v-for="{title, icon, onClick} in postActions"
                        :key="title"
                        ripple
                        :data-qe-id="`post-owner_option_${title}`"
                        @click="onClick(post.id)">
                        <v-list-tile-action>
                            <v-icon>{{icon}}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{title}}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <v-dialog
                v-model="deleteDialog"
                lazy
                absolute
                content-class="post-actions">
                <v-card>
                    <v-flex tag="h6">Delete
                        <v-btn
                            icon
                            class="delete-dialog__close-btn"
                            @click="cancelDeletePost()"
                            data-qe-id="close_dialog_btn">
                            <v-icon size="20">close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex tag="p">
                        {{communityCommonConstant.post.DELETE_CONFIRMATION}}
                    </v-flex>

                    <v-flex text-xs-right>
                        <v-btn
                            flat
                            @click="cancelDeletePost()"
                            data-qe-id="cancel_dialog_btn"
                            class="primary_btn transparent delete-dialog__popupclose_btn ">
                            {{appCommonConstants.CANCEL}}
                        </v-btn>
                        <v-btn
                            dark
                            @click="confirmDeletePost()"
                            data-qe-id="save_dialog_btn"
                            class="primary_btn delete-dialog__delete_btn">
                            {{appCommonConstants.DELETE}}
                        </v-btn>
                    </v-flex>

                </v-card>
            </v-dialog>

            <v-dialog
                v-model="inappropriatePostDialog"
                lazy
                absolute
                content-class="post-actions">
                <v-card>
                    <v-flex tag="h6">Inappropriate {{dialogueTitle}}
                        <v-btn
                            icon
                            class="inappropriate-post-dialog__close-btn"
                            data-qe-id="close_dialog_btn"
                            @click="cancelInappropriatePost()">
                            <v-icon size="20">close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex tag="p">
                        {{communityCommonConstant.post.INAPPROPRIATE_CONFIRMATION_PART1}} {{dialogueTitle}}
                        {{communityCommonConstant.post.INAPPROPRIATE_CONFIRMATION_PART2}}
                    </v-flex>

                    <v-flex text-xs-right>
                        <v-btn
                            flat
                            @click="cancelInappropriatePost()"
                            data-qe-id="cancel_dialog_btn"
                            class="primary_btn transparent inappropriate-post-dialog__popupclose_btn">
                            {{appCommonConstants.CANCEL}}
                        </v-btn>
                        <v-btn
                            dark
                            @click="confirmInappropriatePost()"
                            data-qe-id="save_dialog_btn"
                            class="primary_btn inappropriate-post-dialog__delete_btn">
                            {{appCommonConstants.HIDE}}
                        </v-btn>
                    </v-flex>
                </v-card>
            </v-dialog>

            <v-dialog
                v-model="inappropriatePostAdminDialog"
                lazy
                absolute
                content-class="post-actions">
                <v-card class="inappropriate-post-dialog">
                    <v-flex tag="h6">{{communityCommonConstant.post.CONFIRM_INAPPROPIRATE}}
                        {{dialogueTitle}}
                        <v-btn
                            icon
                            @click="cancelAdminInappropriatePost()"
                            data-qe-id="close_dialog_btn">
                            <v-icon size="20">close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex tag="p">
                        {{communityCommonConstant.post.INAPPROPRIATE_CONFIRMATION_PART1}} {{dialogueTitle}}
                        {{communityCommonConstant.post.INAPPROPRIATE_CONFIRMATION_PART2}}
                    </v-flex>
                    <v-flex text-xs-right>
                        <v-btn
                            class="primary_btn transparent"
                            @click="cancelAdminInappropriatePost()"
                            data-qe-id="cancel_dialog_btn">
                            {{appCommonConstants.CANCEL}}
                        </v-btn>
                        <v-btn
                            class="primary_btn"
                            @click="confirmAdminInappropriatePost(false)"
                            data-qe-id="save_no_dialog_btn">{{appCommonConstants.NO}}
                        </v-btn>
                        <v-btn
                            class="primary_btn"
                            @click="confirmAdminInappropriatePost(true)"
                            data-qe-id="save_yes_dialog_btn">{{appCommonConstants.YES}}
                        </v-btn>
                    </v-flex>
                </v-card>
            </v-dialog>

            <v-dialog
                v-model="hidePostDialog"
                lazy
                absolute
                content-class="post-actions">
                <v-card>
                    <v-flex tag="h6">Hide {{dialogueTitle}}
                        <v-btn
                            icon
                            @click="cancelHidePost()"
                            data-qe-id="close_dialog_btn">
                            <v-icon size="20">close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex tag="p">
                        {{communityCommonConstant.post.HIDE_CONFIRMATION_1}} {{dialogueTitle}}
                        {{communityCommonConstant.post.HIDE_CONFIRMATION_2}}
                    </v-flex>

                    <v-flex text-xs-right>
                        <v-btn
                            flat
                            @click="cancelHidePost()"
                            data-qe-id="cancel_dialog_btn"
                            class="primary_btn transparent">
                            {{appCommonConstants.CANCEL}}
                        </v-btn>
                        <v-btn
                            dark
                            data-qe-id="save_dialog_btn"
                            @click="hidePosts()"
                            class="primary_btn">
                            {{appCommonConstants.HIDE}}
                        </v-btn>
                    </v-flex>
                </v-card>
            </v-dialog>

            <v-dialog
                v-model="removeMentionDialog"
                lazy
                absolute
                content-class="remove-tag-dialog"
                max-width="600px">
                <v-card>
                    <v-card-title>
                        <v-layout align-center justify-space-between>
                            <div class="headline">{{communityCommonConstant.post.MENTION}}</div>
                            <v-btn
                                icon
                                class="delete-dialog__close-btn"
                                data-qe-id="close_dialog_btn"
                                @click="cancelRemoveMention()">
                                <v-icon size="30">{{communityCommonConstant.post.CLOSE}}</v-icon>
                            </v-btn>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        {{communityCommonConstant.post.REMOVE_TAG}}
                    </v-card-text>
                    <v-card-actions>
                        <v-layout justify-end>
                            <v-btn
                                flat
                                @click="cancelRemoveMention()"
                                data-qe-id="cancel_dialog_btn"
                                class="delete-dialog__popupclose_btn ">
                                {{appCommonConstants.CANCEL}}
                            </v-btn>
                            <v-btn
                                dark
                                @click="confirmRemoveMention()"
                                data-qe-id="save_dialog_btn"
                                class="delete-dialog__delete_btn">
                                {{appCommonConstants.REMOVE}}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog
                v-model="canCommentHandlerBox"
                lazy
                absolute
                content-class="post-actions">
                <v-card>
                    <v-flex tag="h6">{{canCommentTitle}}
                        <v-btn
                            icon
                            @click="closeCanCommentHandlerBox()"
                            data-qe-id="close_dialog_btn">
                            <v-icon size="20">close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex tag="p">
                        {{canCommentQuestion}}
                    </v-flex>

                    <v-flex text-xs-right>
                        <v-btn
                            flat
                            @click="closeCanCommentHandlerBox()"
                            data-qe-id="cancel_dialog_btn"
                            id="cancel_can_comment_handler_btn"
                            class="primary_btn transparent">
                            {{appCommonConstants.CANCEL}}
                        </v-btn>
                        <v-btn
                            dark
                            @click="handleCanComment()"
                            id="submit_can_comment_handler_btn"
                            data-qe-id="save_dialog_btn"
                            class="primary_btn">
                            {{appCommonConstants.CONTINUE}}
                        </v-btn>
                    </v-flex>

                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  communityCommonConstant,
  moderationActions,
  postActionPermissions,
} from "@/components/ChapterPage/communityCommon.constant";
import moment from 'moment';
import { storeMutation } from "@/store/storeMutations.constant";
import { storeAction } from "@/store/storeActions.constant";
import { appCommonConstants, routerNames } from "../../appCommon.constants";
import { storeGetters } from "../../../store/storeGetters.constant";
import { imageErrorFallback } from "../../../common/utils/utils";
import { gaDataLayerEvent } from "@/plugins/analytics";
import { gtmEventName } from "@/plugins/gtmAnalytics";
import { sizeFormattedImageUrl } from "@/common/utils/cloudinaryUtils";

export default {
        name: "PostOwner",
        components: {},
        data: () => ({
            communityCommonConstant,
            appCommonConstants,
            routerNames,
            deleteDialog: false,
            inappropriatePostDialog: false,
            inappropriatePostAdminDialog: false,
            dialogueTitle: "",
            hidePostDialog: false,
            canCommentHandlerBox: false,
            removeMentionDialog: false,
            sizeFormattedImageUrl,
        }),
        props: {
            post: {
                required: true,
            },
            actions: {
                required: true,
            },
            isAdminPagePost: {
                type: Boolean,
                default: false,
            },
            canEditAllActivityFeed: {
                type: Boolean,
                default: true,
            },
        },
        methods: {
            ...mapMutations("chapter", [storeMutation.editPost]),
            ...mapActions("chapter", [
                storeAction.sendDeletePost,
                storeAction.sendInappropriatePost,
                storeAction.hidePost,
                storeAction.sendRemoveMention,
                storeAction.submitPostEdit,
            ]),
            ...mapActions({
                sendConfirmationInappropriatePost: `chapter/${
                    storeAction.sendConfirmationInappropriatePost
                    }`,
                getCurrentUserId: `memberProfile/${storeAction.getCurrentUserId}`,
                sendRemovePostModeration: `chapter/${storeAction.sendRemovePostModeration}`,
                getChapterAdmin: `memberProfile/${storeAction.getChapterAdmin}`,
            }),
            imageErrorFallback,
            openCommunity(post) {
                this.$router.push({
                    path: `/${post.communityType.toLowerCase()}/${post.communityId}`,
                });
            },
            promptDeletePost() {
                this.deleteDialog = true;
            },
            cancelDeletePost() {
                this.deleteDialog = false;
            },
            confirmDeletePost() {
                this.deleteDialog = false;
                this.sendDeletePost(this.post.id);
                gaDataLayerEvent(gtmEventName.C_Delete_Post, this.postTrackingData);
            },
            promptInappropriatePost() {
                this.getTitle();
                this.inappropriatePostDialog = true;
            },
            cancelInappropriatePost() {
                this.inappropriatePostDialog = false;
            },
            confirmInappropriatePost() {
                this.inappropriatePostDialog = false;
                this.sendInappropriatePost({ postId: this.post.id, communityTypeName: this.post.communityType });
                gaDataLayerEvent(gtmEventName.C_Inappropriate_Post, this.postTrackingData);
            },
            promptAdminInappropriatePost() {
                this.getTitle();
                this.inappropriatePostAdminDialog = true;
            },
            cancelAdminInappropriatePost() {
                this.inappropriatePostAdminDialog = false;
            },
            confirmAdminInappropriatePost(isConfirmed) {
                this.inappropriatePostAdminDialog = false;
                this.sendConfirmationInappropriatePost({
                    postId: this.post.id,
                    isConfirmed,
                    parentPostId: this.post.parentPostId,
                    postType: this.dialogueTitle,
                });
                gaDataLayerEvent(isConfirmed ?
                    gtmEventName.C_Admin_Confirm_Inappropriate_Post
                    : gtmEventName.C_Admin_Confirm_Not_Inappropriate_Post, this.postTrackingData);
            },

            promptHidePost() {
                this.getTitle();
                this.hidePostDialog = true;
            },
            copyLink(postId) {
                const postUrl = `${window.location.origin}/#/${this.$route.name}/${this.post.communityId}?postId=${postId}`;
                navigator.clipboard.writeText(postUrl).then(() => {
                this.$store.dispatch(`snackbar/${storeAction.setToastMessage}`, {
                    color: 'success',
                    message: this.communityCommonConstant.COPY_LINK,
                });
                }).catch((err) => {
                this.$store.dispatch(`snackbar/${storeAction.setToastMessage}`, {
                    color: 'error',
                    message: this.communityCommonConstant.COPY_FAILED_LINK,
                });
                console.error('Failed to copy link: ', err);
                });
            },
            cancelHidePost() {
                this.hidePostDialog = false;
            },
            hidePosts() {
                this.hidePostDialog = false;
                this.hidePost(this.post.id);
                gaDataLayerEvent(gtmEventName.C_Hide_Post, this.postTrackingData);
            },
            promptCanEditCommentHandlerBox() {
                this.canCommentHandlerBox = true;
            },
            closeCanCommentHandlerBox() {
                this.canCommentHandlerBox = false;
            },
            handleCanComment() {
                this.canCommentHandlerBox = false;
                this.post.canComment = !this.post.canComment;
                if (!this.post.canComment) gaDataLayerEvent(gtmEventName.C_Post_Comments_Disabled, this.postTrackingData);
                this.submitPostEdit(this.post);
            },
            getTitle() {
                this.dialogueTitle = "post";
                if (this.post.parentPostId && this.actions.some(element => element.name.toLowerCase().includes("comment"))) {
                    this.dialogueTitle = "comment";
                } else if (this.post.parentPostId && this.actions.some(element => element.name.toLowerCase().includes("reply"))) {
                    this.dialogueTitle = "reply";
                }
            },
            cancelRemoveMention() {
                this.removeMentionDialog = false;
            },
            confirmRemoveMention() {
                this.removeMentionDialog = false;
                this.sendRemoveMention(this.post.id);
            },
            promptRemoveMention() {
                this.removeMentionDialog = true;
            },
            confirmShowModeratedPost() {
                this.sendRemovePostModeration(this.post.id);
            },
            openMemberProfile() {
                if (this.currentUserId === this.post.authorId) {
                    this.$router.push({
                        path: '/memberProfile',
                        query: {
                            memberId: this.post.authorId,
                            name: this.communityInfo && !this.$route.name.includes('home') ? this.communityInfo.name : this.communityCommonConstant.YPO_HOME,
                            mode: this.routerNames.EDIT,
                        },
                    });
                } else {
                    this.getChapterAdmin(this.post.authorId)
                    .then(() => {
                        if (this.chapterAdmin) {
                            this.$router.push({
                                path: '/memberProfile',
                                query: {
                                    memberId: this.post.authorId,
                                    name: this.communityInfo && !this.$route.name.includes('home') ? this.communityInfo.name : this.communityCommonConstant.YPO_HOME,
                                    mode: this.routerNames.EDIT,
                                },
                            });
                        } else {
                            this.$router.push({
                                path: '/memberProfile',
                                query: {
                                    memberId: this.post.authorId,
                                    name: this.communityInfo && !this.$route.name.includes('home') ? this.communityInfo.name : this.communityCommonConstant.YPO_HOME,
                                },
                            });
                        }
                    });
                }
            },
            showHideReasonBox() {
                this.$emit('handleHideReason', true);
            },
        },
        computed: {
            ...mapGetters({
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                communityInfo: `chapter/${storeGetters.communityInfo}`,
                [storeGetters.usersCommunitiesList]: `chapter/${storeGetters.usersCommunitiesList}`,
                chapterAdmin: `memberProfile/${storeGetters.chapterAdmin}`,

            }),
            postTrackingData() {
              let trackingData = 'post';
              if (this.post) {
                trackingData = this.post.communityId
                    ? `Community_${this.post.id} | Post_${this.post.id}`
                    : `HomePage | Post_${this.post.id}`;
              }
              return trackingData;
            },
            postTime() {
              return moment(this.post.lastUpdated).format('dddd, D MMMM YYYY [at] h:mm A');
            },
            commentOwnerName() {
                return `${this.post.authorFirstName} ${this.post.authorLastName}`;
            },
            canCommentTitle() {
                return this.post.canComment ?
                    communityCommonConstant.post.DISABLE_COMMENT_TITLE :
                    communityCommonConstant.post.ENABLE_COMMENT_TITLE;
            },
            canCommentIcon() {
                return this.post.canComment ?
                    communityCommonConstant.post.DISABLE_COMMENT_ICON :
                    communityCommonConstant.post.ENABLE_COMMENT_ICON;
            },
            canCommentQuestion() {
                return this.post.canComment ?
                    communityCommonConstant.post.DISABLE_COMMENT_QUESTION :
                    communityCommonConstant.post.ENABLE_COMMENT_QUESTION;
            },
            postActions() {
                const convertHandlerName = (name) => {
                    return this.hasOwnProperty(name) && typeof this[name] === "function" ?
                        this[name].bind(this) :
                        () => {};
                };
                if (this.post.isPendingModeration) {
                    let actions = moderationActions;
                    if (!this.post.canEdit) {
                        actions = actions.filter((action) => {
                            const editPermission = moderationActions.edit;
                            const requiredPermissions = action.requiredPermissions || [];
                            return !requiredPermissions.includes(editPermission);
                        });
                    }
                    return actions.map(action => ({
                        ...action,
                        title: action.name === communityCommonConstant.post.CAN_COMMENT ?
                            this.canCommentTitle : action.title,
                        icon: action.name === communityCommonConstant.post.CAN_COMMENT ?
                            this.canCommentIcon : action.icon,
                        onClick: convertHandlerName(action.onClick),
                    }));
                } else if (!this.post.isPendingModeration) {
                    let { actions } = this;
                    if (!this.post.canEdit) {
                        actions = actions.filter((action) => {
                            const editPermission = postActionPermissions.edit;
                            const requiredPermissions = action.requiredPermissions || [];
                            return !requiredPermissions.includes(editPermission);
                        });
                    }
                    if (!this.post.isMentioned) {
                        actions = actions.filter((action) => {
                            const removeMentionPermission = postActionPermissions.isMentioned;
                            const requiredPermissions = action.requiredPermissions || [];
                            return !requiredPermissions.includes(removeMentionPermission);
                        });
                    }
                    if (!this.post.canDelete) {
                        actions = actions.filter((action) => {
                            const deletePermission = postActionPermissions.delete;
                            const requiredPermissions = action.requiredPermissions || [];
                            return !requiredPermissions.includes(deletePermission);
                        });
                    }
                    if (this.$route.path.includes('/forum') || !this.canEditAllActivityFeed) {
                        actions = actions.filter((action) => {
                            const inappropriatePermission = postActionPermissions.inappropriatePost;
                            const requiredPermissions = action.requiredPermissions || [];
                            return !requiredPermissions.includes(inappropriatePermission);
                        });
                    }

                    if (!this.canEditAllActivityFeed) {
                        actions = actions.filter((action) => {
                            return action.name !== 'hidePost' && action.name !== 'hideComment' && action.name !== 'hideReply';
                        });
                    }
                    return actions.map(action => ({
                        ...action,
                        title: action.name === communityCommonConstant.post.CAN_COMMENT ?
                            this.canCommentTitle : action.title,
                        icon: action.name === communityCommonConstant.post.CAN_COMMENT ?
                            this.canCommentIcon : action.icon,
                        onClick: convertHandlerName(action.onClick),
                    }));
                }
            },
            showCommunityAllNetwork_Home() {
                return (
                    !this.$route.params.communityId && this.$route.name && this.$route.name.toLowerCase() === 'home')
                    || (
                        this.usersCommunitiesList
                        && this.usersCommunitiesList.some(o => o.communityId === this.$route.params.communityId)
                        && this.usersCommunitiesList.find(o => o.communityId === this.$route.params.communityId).name === "All Networks"
                    );
            },

        },
        created() {
            this.getCurrentUserId();
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../common/styles/_colors.scss";
    @import "../../../common/styles/_commonClasses.scss";
    @import "../../../common/styles/_responsive.scss";

    .owner {
        &__name {
            text-align: left;
            font-size: 14px;
            font-weight: 600;
            color: $ypo-gray-text;
        }

        &__listavatar {
            padding: 0 5px !important;
        }

        &__chapter {
            text-align: left;
            margin-top: 5px;
            font-size: 12px;
            color: $ypo-dark-gray;
        }

        &__community {
                color: $ypo-gold;
                cursor: pointer;
        }

        &__detail {
            text-align: right;

            &-time {
                padding-right: 5px;
                font-size: 12px;
                color: $black;
                display: flex;
                align-items: center;
                white-space: nowrap;
                text-overflow: ellipsis;
                @include breakpoint(xs) {
                    display: none;
                }
                &__icon {
                    padding: 0 5px;
                }
            }
        }

        &__menu {
            border-radius: 3px;
            padding: 0;

            .v-list__tile__content {
                font-size: 14px;
                color: $ypo-dark-background-gray;
            }

            .v-icon {
                font-size: 14px;
                color: $ypo-dark-background-gray;
            }

            .v-list__tile__action {
                min-width: 30px;
            }
        }

        &__time_align {
            padding-right: 15px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            position: relative;
            z-index: 1;
            transform: translateZ(0);
        }

        &__menu-item {
            color: $ypo_title_blue_gray;
            font-weight: bold;
            min-width: 14em;
            height: 45px;
            overflow: hidden;
            font-size: 12px;
            text-transform: inherit;
            letter-spacing: 0;
        }
    }

    .v-menu__activator {
        i {
            position: relative;
            background-color: $ypo-extra-light-gray;
            width: 12px;
            margin-left: 12px;
        }
    }

    .post_option_btn {
        position: relative;
        top: -4px;
    }

    .menu-tile {
        z-index: 1;
    }

    .v-menu__content {
        border: 1px solid $ypo-medium-gray;
        border-radius: 4px;
        background-color: $white;
        box-shadow: 0 1px 3px 0 rgba($black, 0.18);
        z-index: 1000 !important;
    }

    .v-menu__content_EP {
        border: 1px solid $ypo-medium-gray;
        border-radius: 4px;
        background-color: $white;
        box-shadow: 0 1px 3px 0 rgba($black, 0.18);
        z-index: 1000 !important;
    }

    .v-list__tile {
        height: 55px !important;

        &:hover {
            background: $ypo-medium-gray !important;

            .v-list__tile__content {
                color: $ypo_blue;
            }

            .v-icon {
                color: $ypo_blue;
            }
        }
    }

    #post_inappropirate_flag_btn {
        margin-right: 5px;
    }

    @media (max-width: 767px) {
        .owner__time_date {
            font-size: 10px;
            margin: 2px 0 0 77px;
            vertical-align: middle;

            i {
                font-size: 14px;
            }
        }

        .v-menu__activator {
            i {
                top: 0px;
                right: 0;
                transform: rotate(90deg);
                background: transparent;
            }
        }

    }

    .inappropriate-post-dialog {
        .primary_btn {
            padding: 8px 25px;
        }
    }
</style><style lang="scss">
    .owner {
        &__time_align {
            .menu-tile {
                z-index: 0;
            }
        }

        .v-list__tile {
            height: auto;
            align-items: flex-start;
        }

    }
</style>
